import { Component, ViewChild } from '@angular/core';
import {
  breadcrumb,
  link,
  stat,
} from '../../../layout/header/header.component';
import {
  ConfirmEventType,
  ConfirmationService,
  MenuItem,
  Message,
  MessageService,
  SelectItem,
} from 'primeng/api';
import { Table } from 'primeng/table';
import { DataService } from 'src/app/services/data.service';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import icons from '../../../../misc/data/icons.json';
import { TextAreaQuestion } from 'src/app/misc/component/dynamic-form/question-textarea';
import { MultiSelectQuestion } from 'src/app/misc/component/dynamic-form/question-multiselect';
import { ConnectableObservable } from 'rxjs';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-role-management',
  templateUrl: './role-management.component.html',
  styleUrls: ['./role-management.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class RoleManagementComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  @ViewChild('dt')
  dt!: Table;

  messages: Message[] = [];
  translator: TranslatorPipe = new TranslatorPipe()

  cols: any[] = [];
  exportColumns: { title: any; dataKey: any }[] = [];

  header = this.translate('Organizing roles');
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-angle-right',
      link: '/admin/users',
      visible: this.permissionService.hasPermission('USER_MANAGEMENT', 'r'),
    },
    // {
    //   name: 'Position',
    //   icon: 'pi pi-verified',
    //   link: '/admin/users/roles/position',
    // },
    {
      name: 'الصلاحيات',
      icon: 'pi pi-shield',
      link: '/admin/users/roles/permission',
      visible: this.permissionService.hasPermission(
        'PERMISSION_MANAGEMENT',
        'r'
      ),
    },
    // {
    //   name: 'الواجهات',
    //   icon: 'pi pi-flag',
    //   link: '/admin/users/roles/interface',
    //   visible:this.permissionService.hasPermission('INTERFACE','r')
    // },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('User console'), link: '/admin/users' },
    { name: this.translate('Organizing roles'), link: '/admin/users/roles' },
  ];
  stats: stat[] = [];

  roleData: any[] = [];

  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  PermissionData: any = [];

  constructor(
    public dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService
  ) { }

  ngOnInit() {
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });

    this.getRoles();
    this.getPermissions().then(() => {
      this.makequestion();
    });
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }


  getPermissions = async () => {
    try {
      let res = await this.dataService.getData('permission');
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.PermissionData = res.data;
      console.log('PERMISSIONS', this.PermissionData);
    } catch (error) {
      console.log(error);
    }
  };

  getRoles = async () => {
    try {
      let res = await this.dataService.getData('role');
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.roleData = res.data;
      console.log(this.roleData);
      this.roleData.forEach((item: any) => {
        let role = {
          // _id: item._id,
          // ID: { n: this.data.length + 1, i: 'pi pi-angle-left' },
          '#': { n: item._id, i: 'pi pi-angle-left' },
          'اسم الدور': { n: item.name, i: item.icon },
          الوصف: { n: item.description },
          الصلاحيات: {
            n: item.permissions.map((obj: any) => obj.name),
          },
          الحالة: {
            n: item.active,
            i: item.active ? 'pi pi-check-circle' : 'pi pi-times-circle',
          },
          Action: [
            {
              n: 'Delete',
              i: 'pi pi-times',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        };

        if (item._id == '64c434e4b3af906a319576d3') {
          role.Action = [
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ]
        }
        this.data.push(role);
      });
      this.skelition = false;
      this.updateRoleCounts();
    } catch (error) {
      console.log(error);
    }
  };

  private updateRoleCounts(): void {
    let activeRole = this.data.filter(
      (item: any) => item['الحالة'].n === true
    ).length;
    let inactiveRole = this.data.length - activeRole;
    this.stats = [
      {
        name: this.translate('active'),
        number: activeRole,
        icon: 'pi pi-check-circle',
      },
      {
        name: this.translate('Inactive'),
        number: inactiveRole,
        icon: 'pi pi-times-circle',
      },
    ];
    console.log('Updating stats', this.stats);
  }

  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: 'اسم الدور',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new TextAreaQuestion({
        key: 'description',
        label: 'الوصف',
        required: true,
        order: 2,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new MultiSelectQuestion({
        key: 'permissions',
        label: 'الصلاحيات',
        required: true,
        options: this.PermissionData,
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 5,
        className: 'col-md-6 col-sm-12 col-12',
        value: true,
        visibility: 'false',
      }),
    ];
  }

  actionCall($event: any) {
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteCatagory($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.roleData.find((item) => item._id == $event.id);

        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: 'اسم الدور',
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-md-12 col-sm-12 col-12',
          }),

          new TextAreaQuestion({
            key: 'description',
            label: 'الوصف',
            required: true,
            order: 2,
            value: this.updateData.description,
            className: 'col-md-12 col-sm-12 col-12',
          }),

          new MultiSelectQuestion({
            key: 'permissions',
            label: 'الصلاحيات',
            required: true,
            options: this.PermissionData,
            order: 4,
            value: this.updateData.permissions,
            className: 'col-md-12 col-sm-12 col-12',
          }),

          new DropdownQuestion({
            key: 'active',
            label: 'الحالة',
            required: true,
            value: this.updateData.active,
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            order: 5,
            className: 'col-md-12 col-sm-12 col-12',
          }),
        ];
        // console.log("Update Data ==>",this.roleData,this.updateData);
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }
  receiveData = async ($event: any) => {
    try {
      let data = $event;

      let newData = data;
      newData.permissions = data.permissions.map((obj: any) => obj._id);
      let permissions: any = [];
      data.permissions.map((obj: any) => {
        permissions.push(this.PermissionData.find((e: any) => e._id == obj));
      });
      console.log(permissions);
      console.log('==>Data Recieved   =', data, newData);

      let res = await this.dataService.postData('role', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();

      data._id = res.data._id;

      data.permissions = permissions;
      this.roleData.push(data);

      console.log(this.roleData);

      this.data.unshift({
        '#': { n: res.data._id, i: 'pi pi-angle-left' },
        'اسم الدور': { n: data.name, i: data.icon },
        'الوصف': { n: data.description },
        'الصلاحيات': { n: permissions.map((e: any) => e.name).join(' ,') },
        'الحالة': {
          n: data.active,
          i: data.active ? 'pi pi-check-circle' : 'pi pi-times-circle',
        },
        Action: [
          {
            n: 'Delete',
            i: 'pi pi-times',
            s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
          },
          {
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          },
        ],
      });
      window.location.reload()
      this.updateRoleCounts();
    } catch (error) {
      console.log(error);
    }
  };

  deleteCatagory = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`role/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.data = this.data.filter((item) => item['#'].n !== id);
      this.roleData = this.roleData.filter((item) => item._id !== id);
      this.updateRoleCounts();
    } catch (error) {
      console.log(error);
    }
  };

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;
      console.log(data);
      let res = await this.dataService.postData('role', data, 'PUT', false);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      console.log(data);
      // updating in table
      const myObject = this.data.find((item) => item['#'].n === data._id);
      (myObject['#'] = { n: data._id, i: 'pi pi-angle-left' }),
        (myObject['اسم الدور'].n = data.name),
        (myObject['اسم الدور'].i = data.icon);
      myObject['الحالة'].n = data.active;
      myObject['الحالة'].i = data.active
        ? 'pi pi-check-circle'
        : 'pi pi-check-circle';

      (myObject['الوصف'] = { n: data.description }),
        (myObject['الصلاحيات'] = {
          n: data.permissions.map((obj: any) => obj.name),
        }),
        console.log('OBJ', myObject);
      this.data.map((e, i) => {
        if (e['#'].n === data._id) {
          this.data[i] = myObject;
          return;
        }
      });

      console.log(this.roleData);
      console.log('UPDATE BEFORE', data);
      this.roleData.map((e, i) => {
        if (e._id === data._id) {
          this.roleData[i] = data;
          return;
        }
      });
      this.updateRoleCounts();

      console.log(this.data);
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }
}
